import { ShopDomainDto } from "@babackapp/private-api-client/types";

export default function useDomainDnsRecordsDownloader() {
  const downloadDnsRecords = (domain: ShopDomainDto) => {
    const { dnsDomainRecords, name: domainName } = domain;
    const csvRows = [];
    const headers = ["Type", "Name", "Value", "Priority"];
    csvRows.push(headers.join(","));

    const records = [
      { type: "TXT", ...dnsDomainRecords.txt },
      {
        type: "MX",
        name: dnsDomainRecords.mx.name,
        value: dnsDomainRecords.mx.value,
        priority: dnsDomainRecords.mx.priority
      },
      { type: "CNAME", ...dnsDomainRecords.cname1 },
      { type: "CNAME", ...dnsDomainRecords.cname2 },
      { type: "CNAME", ...dnsDomainRecords.cname3 }
    ];

    for (const record of records) {
      const values =
        record.priority !== undefined
          ? [record.type, record.name, record.value, record.priority]
          : [record.type, record.name, record.value];
      csvRows.push(values.join(","));
    }

    const csvContent = `data:text/csv;charset=utf-8,${csvRows.join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${domainName}-dns-records.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return downloadDnsRecords;
}